var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"col-6"},[_c('h4',{staticClass:"text-left mr-3",staticStyle:{"color":"black"}},[_vm._v("Ricarico  "),_c('span',{staticClass:"badge badge-danger"},[_vm._v(_vm._s(_vm.markUp))])])])])}
var staticRenderFns = []

export { render, staticRenderFns }